// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2ZuUK","left":"StickyBox_left__2kLqv","right":"StickyBox_right__3QZUy"};